import { render } from "./CreateBusiness.vue?vue&type=template&id=571e4d48&scoped=true"
import script from "./CreateBusiness.vue?vue&type=script&lang=js"
export * from "./CreateBusiness.vue?vue&type=script&lang=js"

import "./CreateBusiness.vue?vue&type=style&index=0&id=571e4d48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-571e4d48"]])

export default __exports__